import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import ThemeValidations from 'scaleflow/validators/theme';

export default class SettingsTagsCreateController extends Controller {
  @service declare router: any;
  @service('beta-toggle') declare betaService: any;

  declare model: any;

  themeValidations = ThemeValidations;

  @action
  cancelForm(changeset: any) {
    changeset.rollback();
    this.model.deleteRecord();
    this.goToListPage();
  }

  @action
  goToListPage() {
    this.router.transitionTo('settings.tags');
  }

  @action
  addTheme(changeset: any) {
    if (changeset.title?.length <= 0) return;
    try {
      changeset.save().then(() => {
        this.goToListPage();
        changeset.rollback();
      });
    } catch (err) {
      console.log(err);
    }
  }

  @action
  onSubmit(changeset: any, e: Event) {
    e.preventDefault();
    this.addTheme(changeset);
  }

  @action
  handleThemeColorSelect(e: string, changeset: any) {
    changeset.set('color', e);
  }

  get body() {
    return document.querySelector('body');
  }
}
